import { Stack } from '@mui/material'

import AccountMenu from '~/layouts/app/header/account/portal/accountMenu'
import SelectAgent from '~/layouts/app/header/account/portal/selectAgent'
import EEnvironmentVariables from '~/models/config'

function PortalAccount() {
  return (
    <Stack sx={{ flexDirection: 'row' }}>
      {import.meta.env[EEnvironmentVariables.VITE_IS_MULTIAGENT_ENABLED] ===
        'true' && <SelectAgent />}
      <AccountMenu />
    </Stack>
  )
}

export default PortalAccount
